import React from 'react';

export default function NotFound() {
    return (
        <div>
            <h1>Page Not Found</h1>
            <p>Sorry, the page you requested was not found. Please check the URL and try again.</p>
        </div>
    );
}